'use client'

import {createContext, startTransition, useContext, useMemo} from "react";
import {getCaseInfoById} from "../../../api/CaseAPI";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import {navMap} from "../../../nav/navMap";
import {useRouter} from "next/navigation";
import {useLoadingContext} from "../../../context/loading";

const ApiMiddlewareLayerContext = createContext({} as {
    handleCaseInfoById: (caseId: string) => Promise<any>,
});

export const ApiClientMiddlewareLayerProvider = ({children}) => {
    const {setLoading} = useLoadingContext();
    const {t, i18n} = useTranslation("status");
    const currentLocale = i18n.language;
    const router = useRouter();

    const handleCaseInfoById = async (caseId: string) => {
        setLoading(true);
        return getCaseInfoById(caseId).then(value => {
            if(value.status === 403) {
                startTransition(async () => {
                    try {
                        toast.error(t("toast.not_allowed"));
                        router.push(navMap.locale(currentLocale).legal());
                    } catch (error) {
                        console.error('Error during redirect:', error);
                    } finally {
                        setLoading(false);
                    }
                });
            }

            if(value.status === 404) {
                startTransition(async () => {
                    try {
                        toast.error(t("toast.not_found"));
                        router.push(navMap.locale(currentLocale).legal());
                    } catch (error) {
                        console.error('Error during redirect:', error);
                    } finally {
                        setLoading(false);
                    }
                });
            }

            return value;
        }).finally(() => setLoading(false))
    }

    const value = useMemo(() => ({ handleCaseInfoById }), []);

    return (
            <ApiMiddlewareLayerContext.Provider value={value}>
                {children}
            </ApiMiddlewareLayerContext.Provider>
    );
}
export const useApiMiddlewareLayerProvider = () => useContext(ApiMiddlewareLayerContext);
